import {i18n} from "./i18n";
import {provider_membership_add, provider_membership_rem} from "./dapiEventUris";
import {FieldHandler} from "./fieldHandler";
import UrlHelpers from "./url";
import {Notification} from "./notification";
import {setContextActions} from "./contextActions";

export class ProviderMembership {
    private _dapi: Dapi = (<any>window).dapi;
    private _dux = (<any>window).dux;
    private _i18n: i18n = new i18n();

    constructor(){
        this._dapi.addResourceEventListener('changed', this._dapi_changed_event);
        this._dapi.addResourceEventListener('deleted', this._dapi_deleted_event);
        this._add_click_event();
        setContextActions(this._dapi, this._i18n, null);
    }

    private _dapi_changed_event = (resourceEvent: IResourceEvent) => {
        if (resourceEvent.name === 'changed' && resourceEvent.uri === provider_membership_add) {
            window.location.reload(true);
        }
    };

    private _dapi_deleted_event = (resourceEvent: IResourceEvent) => {
        if (resourceEvent.name==='deleted' && resourceEvent.uri.startsWith(provider_membership_rem)){
            let counter = resourceEvent.uri.substr(resourceEvent.uri.lastIndexOf('/')+1);
            let id = 'membership-row-'+counter;
            let tr = document.getElementById(id);
            tr.remove();
        }
    };

    private _add_click_event = () => {
        let btnAdd = document.getElementById('btnAddMember');
        if(!btnAdd) {
            console.error("cannot find button to adding member");
            return
        }
        btnAdd.addEventListener('click', this._btn_add_member_click);

        let memberinput = document.getElementById('memberId');
        if(!memberinput){
            console.error("cannot find member input field");
            return
        }
        memberinput.addEventListener('keyup',this._on_membership_input_field_press_enter);

        let elements = document.getElementsByName('btnRemoveMembership');
        for (let i = 0; i < elements.length; i++) {
            let btn = elements[i];
            btn.addEventListener('click', this._btn_remove_member_click)
        }
    };

    private _btn_remove_member_click = (e:any) => {
        let current = e.currentTarget;
        let id = current.dataset["id"];
        let member = current.dataset["member"];
        let provider = FieldHandler.getFieldValue('providerId');
        let dto:providerMembershipRequestDto = {
            id:provider,
            member:member
        };
        let url = UrlHelpers.getLinkRelHref('self');
        let xhr = new XMLHttpRequest();
        xhr.open('DELETE', url);
        xhr.setRequestHeader('accept', 'application/json');
        xhr.onload = () => {
            if (xhr.status === 204) {
                this._dapi.dispatchResourceEvent({
                    name:'deleted',
                    uri: provider_membership_rem+'/'+id
                });
            } else {
                Notification.showErrorNotification(this._i18n.getTranslation('provider_membership_notification_delete_member_failed_title'), this._i18n.getTranslation('provider_membership_notification_delete_member_failed_message'));
                console.error(xhr.status+": "+xhr.responseText);
            }
        };
        xhr.send(JSON.stringify(dto));
    };

    private _on_membership_input_field_press_enter = (e: any) => {
        if (e.keyCode === 13) {
            this._btn_add_member_click();
        }
    };

    private _btn_add_member_click = () => {
        let member = FieldHandler.getFieldValue('memberId');
        if (member.indexOf('@') === -1) {
            console.info("member is not a valid mail adress: ", member);
            return
        }
        let provider = FieldHandler.getFieldValue('providerId');
        let dto : providerMembershipRequestDto = {
            id:provider,
            member:member
        };
        let url = UrlHelpers.getLinkRelHref('self');
        let xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.setRequestHeader('accept', 'application/json');
        xhr.onload = () => {
            if (xhr.status === 200) {
                this._dapi.dispatchResourceEvent({
                    name: "changed",
                    uri: provider_membership_add
                });
            } else if (xhr.status === 409) {
                // info: member already exist
                Notification.showInfoNotification(this._i18n.getTranslation('provider_membership_notification_member_already_exist_title'), this._i18n.getTranslation('provider_membership_notification_member_already_exist_message'));
            } else {
                Notification.showErrorNotification(this._i18n.getTranslation('provider_membership_notification_failed_title'), this._i18n.getTranslation('provider_membership_notification_failed_message'));
                console.error(xhr.status + ": " + xhr.responseText);
            }
        };
        xhr.send(JSON.stringify(dto));
    };
}

export interface providerMembershipRequestDto {
    id:string
    member:string
}